<template>
    <div class="tab-pane fade" id="receipts">
        <h3>Danh sách đơn xuất</h3>
        <div class="table-responsive">
            <hpo-filter :headers="receipt_headers" :viewName="'account_receipts'" v-on:applyFilter="applyFilterReceipt"
                v-on:quickFilter="quickFilterReceipt"></hpo-filter>
            <v-data-table :headers="receipt_headers" :items="receipts" :options.sync="receipt_pagination"
                :server-items-length="total_receipt" :footer-props="items_per_page" :must-sort="true" :loading="loading"
                :mobile-breakpoint="100" class="elevation-1 free-col">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>HD{{ pad(item.id, 6) }}</td>
                        <td>{{ item.created_at | display_date }}</td>
                        <td class="text-right">{{ item.total | currency }}</td>
                        <td class="text-right">{{ item.discount | currency }}</td>
                        <td class="text-right">{{ item.amount | currency }}</td>
                        <td><a @click="openReceiptDetail(item.id)">Xem</a></td>
                    </tr>
                </template>
                <template v-slot:body.append v-if="summary_receipt">
                    <tr class="total-summary-td">
                        <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ summary_receipt.total | currency }}</td>
                        <td class="text-end font-weight-bold">{{ summary_receipt.discount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ summary_receipt.amount | currency }}</td>
                        <td></td>
                    </tr>
                </template>
            </v-data-table>
        </div>
        <v-dialog v-model="dialogDetailReceipt" max-width="800px">
            <v-card v-if="selectedReceipt">
                <v-card-title>
                <span class="title">Chi tiết đơn xuất #{{ selectedReceipt.id }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-layout row wrap>
                            <v-flex lg12 md12 sm12>
                                <v-text-field v-model="selectedReceipt.transaction_code" label="Mã vận đơn" readonly></v-text-field>
                            </v-flex>
                            <v-flex lg12 md12 sm12>
                                <v-data-table :headers="detail_header" :items="selectedReceipt.receipt_products" disable-pagination hide-default-footer :mobile-breakpoint="100">
                                    <template v-slot:item="{ item }">
                                        <tr>
                                            <td>{{ item.product_code }}</td>
                                            <td>{{ item.product_name }}</td>
                                            <td class="text-right">
                                                {{ item.qty | currency }}
                                            </td>
                                            <td class="text-right">
                                                {{ item.unit_price | currency }}
                                            </td>
                                            <td class="text-right">
                                                {{ item.discount | currency }}
                                            </td>
                                            <td class="text-right">
                                                {{ item.price | currency }}
                                            </td>
                                            <td class="text-right">
                                                {{ item.line_total | currency }}
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="printData">In HĐ</v-btn>
                    <v-btn color="red darken-1 white--text" @click="dialogDetailReceipt = false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
import Filtering from "@/components/Filtering";
import _ from 'lodash';
import { display_color } from "@/commons/formater";
import { sendErrorNotice, pad } from '@/commons/utils'
import { print_export_receipt } from "@/commons/hpod";
import moment from "moment"
export default {
    components: {
        "hpo-filter": Filtering
    },
    data () {
        return {
            viewName: "account_receipts",
            pad: pad,
            display_color: display_color,
            receipt_headers: [{
                    text: "Mã đơn",
                    value: "id",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ngày tạo",
                    value: "created_at",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Tổng tiền",
                    value: "total",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Giảm giá",
                    value: "discount",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng sau giảm",
                    value: "amount",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    width: "40px"
                }
            ],
            detail_header: [
                {
                    text: "Mã SP",
                    value: "product_code",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                },
                {
                    text: "Tên SP",
                    value: "product_name",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                },
                {
                    text: "SL",
                    value: "qty",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Đơn giá",
                    value: "unit_price",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Giảm giá",
                    value: "discount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Giá bán",
                    value: "price",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Thành tiền",
                    value: "line_total",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                }
            ],
            receipt_pagination: {...configs.PAGINATION, itemsPerPage: 10},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterReceiptConditions: [],
            quickFilterReceiptConditions: [],
            selectedItem: null,
            dialogItem: false,
            dialogDetailReceipt: false
        }
    },
    computed: {
        ...mapState({
            receipts: state => state.receipts.all.data,
            total_receipt: state => state.receipts.all.total,
            summary_receipt: state => state.receipts.all.summary,
            selectedReceipt: state => state.receipts.selected,
            loading: state => state.receipts.loading
        }),
        customer_id() {
            return this.$store.state.authentication.user.id;
        },
    },
    watch: {
        receipt_pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterReceiptConditions = !_.isEmpty(filterConditions) ? filterConditions['account_receipts'] : []
                this.filter_data();
            },
            deep: true
        },
    },
    methods: {
        refresh_data() {
            this.filter_data();
        },
        filter_data() {
            var param = {
                pagination: this.receipt_pagination,
                filter: this.filterReceiptConditions,
                quickFilter: this.quickFilterReceiptConditions
            };
            this.$store.dispatch("receipts/getList", param);
        },
        applyFilterReceipt(filterConditions) {
            let sortBy = this.receipt_pagination.sortBy
            let sortDesc = this.receipt_pagination.sortDesc
            this.receipt_pagination = {...configs.PAGINATION, itemsPerPage: 10};
            this.receipt_pagination.sortBy = sortBy;
            this.receipt_pagination.sortDesc = sortDesc;
            this.filterReceiptConditions = filterConditions;
            this.filter_data();
        },
        quickFilterReceipt(filterConditions) {
            this.quickFilterReceiptConditions = filterConditions;
            this.filter_data();
        },
        openReceiptDetail(id) {
            this.$store.dispatch("receipts/getDetail", id)
            this.dialogDetailReceipt = true;
        },
        printData() {
            if(!this.selectedReceipt) {
                sendErrorNotice('Lỗi không thể in hoá đơn.');
                return;
            }
            this.$store.dispatch("users/getDebt", {date: moment.parseZone(this.selectedReceipt.created_at).format(configs.SQL_DATE_FORMAT)}).then((debt) => {
                const frame_printing = print_export_receipt(this.selectedReceipt, this.selectedReceipt.receipt_products, debt);
                var doc = document.getElementById('print_frame').contentWindow.document;
                doc.open();
                doc.write(frame_printing);
                doc.close();
                setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
            });
        },
    },
    mounted () {
        this.filter_data();
        this.$root.$emit('COMPONENT_LOADED');
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$on("REQUEST_REFRESH_DATA", this.refresh_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
}
</script>